import { BaseTransport, VERSION } from "@grafana/faro-core";
import { documentLoadSpan } from "./logExport";
import { Faro } from "@grafana/faro-web-sdk";

class TraceLogTransport extends BaseTransport {
  readonly name = "@grafana/faro-web-sdk:transport-trace-log";
  readonly version = VERSION;
  private faroInstance: Faro;
  private ignoreUrls: Array<string | RegExp>;

  constructor(faroInstance: Faro, ignoreUrls: Array<string | RegExp> = []) {
    super();
    this.faroInstance = faroInstance;
    this.ignoreUrls = ignoreUrls;
  }

  async send(item: any): Promise<void> {
    if (item.type === "trace") {
      const payload = item.payload;
      const resSpans = payload["resourceSpans"];
      resSpans.forEach((resSpan: any) => {
        const scopeSpans = resSpan["scopeSpans"];
        scopeSpans.forEach((scope: any) => {
          const instrumentationName = scope["scope"]["name"];
          if (
            instrumentationName === "@opentelemetry/instrumentation-document-load" ||
            instrumentationName === "@opentelemetry/instrumentation-fetch" ||
            instrumentationName === "@opentelemetry/instrumentation-xml-http-request"
          ) {
            const documentScope = documentLoadSpan(scope, this.ignoreUrls);
            documentScope.forEach((docScope) => {
              this.faroInstance.api.pushLog([JSON.stringify(docScope)]);
            });
          }
        });
      });
    }
  }
}

export default TraceLogTransport;
